import React, { Component } from "react";
import PropTypes from "prop-types";

import { drawOnCanvas, renderSVG } from "./EdgeCoordinateV3";
import GenericChartComponent from "../GenericChartComponent";
import { getMouseCanvas } from "../GenericComponent";
import { functor, isNotDefined } from "../utils";

class XCoordinate extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
    this.drawOnCanvas = this.drawOnCanvas.bind(this);
  }
  drawOnCanvas(ctx, moreProps) {
    const props = helper(this.props, moreProps);
    if (isNotDefined(props)) return;
    drawOnCanvas(ctx, props);
  }
  renderSVG(moreProps) {
    const props = helper(this.props, moreProps);
    if (isNotDefined(props)) return null;
    return renderSVG(props);
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        canvasDraw={this.drawOnCanvas}
        canvasToDraw={getMouseCanvas}
        drawOn={["pan", "drag", "mousemove"]}
      />
    );
  }
}

XCoordinate.propTypes = {
  xValue: PropTypes.any.isRequired,
  displayFormat: PropTypes.func.isRequired,
  orient: PropTypes.oneOf(["top", "bottom"]),
  at: PropTypes.oneOf(["top", "bottom"]),
  rectWidth: PropTypes.number,
  rectHeight: PropTypes.number,
  arrowWidth: PropTypes.number,
  dy: PropTypes.number,
  fill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  opacity: PropTypes.number,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  textFill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  stroke: PropTypes.string,
  strokeOpacity: PropTypes.number,
  strokeWidth: PropTypes.number,
  lineOpacity: PropTypes.number,
  lineStroke: PropTypes.string,
};

XCoordinate.defaultProps = {
  orient: "bottom",
  at: "bottom",
  rectWidth: 80,
  rectHeight: 20,
  arrowWidth: 0,
  dy: 0,
  fill: "#2196F3",
  opacity: 1,
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 12,
  fontWeight: "normal",
  textFill: "#FFFFFF",
  stroke: "#2196F3",
  strokeOpacity: 1,
  strokeWidth: 1,
  lineOpacity: 0,
  lineStroke: "#2196F3",
};

function helper(props, moreProps) {
  const { xValue, orient, at, rectWidth, rectHeight, arrowWidth, dy } = props;
  const { fill, opacity, fontFamily, fontSize, fontWeight, textFill } = props;
  const { stroke, strokeOpacity, strokeWidth, lineOpacity, lineStroke } = props;
  const { height } = moreProps.chartConfig;
  const { xScale } = moreProps;

  if (isNotDefined(xValue) || isNotDefined(xScale)) return null;

  const range = xScale.range();
  const minX = Math.min(range[0], range[range.length - 1]);
  const maxX = Math.max(range[0], range[range.length - 1]);

  const x = xScale(xValue);

  const show = x >= minX && x <= maxX;
  if (!show) return null;

  const edgeAt = at === "top" ? 0 : height;

  const formatter =
    props.displayFormat ||
    ((value) =>
      value instanceof Date ? value.toLocaleString() : String(value));
  const rawValue =
    typeof xScale.invert === "function" ? xScale.invert(x) : xValue;
  const coordinate = formatter(rawValue, moreProps);

  const coordinateProps = {
    coordinate,
    show: true,
    type: "vertical",
    orient,
    edgeAt,
    hideLine: true,
    lineOpacity,
    lineStroke,
    stroke,
    strokeOpacity,
    strokeWidth,
    fill: functor(fill)(xValue),
    textFill: functor(textFill)(xValue),
    opacity,
    fontFamily,
    fontSize,
    fontWeight,
    rectWidth,
    rectHeight,
    arrowWidth,
    x1: x,
    x2: x,
    y1: 0,
    y2: height,
    dy,
  };

  return coordinateProps;
}

export default XCoordinate;
